/* unplugin-vue-components disabled */import { render } from "./TagView.vue?vue&type=template&id=6f0c0c85&scoped=true"
const script = {}

import "./TagView.vue?vue&type=style&index=0&id=6f0c0c85&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0c0c85"]])

export default __exports__